
import halfYearOverView from '@mentee/api/halfYearOverview';

const ACTION_PREFIX = 'MENTEE/PROFILE_SHARE';
const SET_COIN_FORM_STATE = `${ACTION_PREFIX}/SET_HALF_YEARLY_COIN_FORM`;
const LINKEDIN_BUTTON_INIT = `${ACTION_PREFIX}/LINKEDIN_BUTTON_INIT`;
const LINKEDIN_BUTTON_DONE = `${ACTION_PREFIX}/LINKEDIN_BUTTON_INIT`;
const LINKEDIN_BUTTON_ERROR = `${ACTION_PREFIX}/LINKEDIN_BUTTON_INIT`;

export function setFormOpenState(payload) {
  return async (dispatch) => {
    dispatch({
      type: SET_COIN_FORM_STATE,
      payload,
    });
  };
}

export function markLinkedinButtonClick() {
  return async (dispatch) => {
    dispatch({
      type: LINKEDIN_BUTTON_INIT,
    });
    try {
      await halfYearOverView.markLinkedinBtnClick();
      dispatch({
        type: LINKEDIN_BUTTON_DONE,
      });
    } catch (error) {
      dispatch({
        type: LINKEDIN_BUTTON_ERROR,
        error,
      });
    }
  };
}

export default function reducer(
  state = {
    coinFormOpenState: false,
  },
  action,
) {
  switch (action.type) {
    case SET_COIN_FORM_STATE:
      return { ...state, coinFormOpenState: action.payload };
    default:
      return state;
  }
}
